import {defineStore} from 'pinia'
import api from '@/services/api'

import {useTemplatesStore} from '@/stores/templates'

export const usePageSectionsStore = defineStore('pageSections', {
    state: () => ({
        items: undefined
    }),
    
    actions: {
        async init(refresh = false) {
            const templatesStore = useTemplatesStore()
            
            if (this.items !== undefined && !refresh) return
            
            this.items = []
            
            const response = await api.get('api/page-section')
            const pageSections = response.data.data
            
            for (let i = 0; i < pageSections.length; i++) {
                const pageSection = pageSections[i]
                
                const template = templatesStore?.items?.find(
                    (o) => o.id === pageSection.sectionTemplateId
                )
                
                let areaKey = 0
                const areas = []
                if (template?.templateHtml) {
                    const matches = template.templateHtml.matchAll(/\{\{ area }}/g)
                    for (const match of matches) {
                        areas.push({
                            value: 'area_' + pageSection.id + '_' + areaKey,
                            text: 'Area ' + (areaKey + 1),
                        })
                        
                        areaKey++
                    }
                }
                
                pageSection.areas = areas
            }
            
            this.items = pageSections
        },
    },
})